// extracted by mini-css-extract-plugin
module.exports = {"graph":"styles_graph__1Ioy3"};